import React, {Component} from 'react';
import {connect} from 'react-redux';

import HomeFE from './FE';
import HomeInternal from './Internal';
import helpers from '../../../utils/helpers';


class Home extends Component {

    constructor(props) {
        super(props);

        let homes = helpers.getUserHomes(this.props.user);
        let multipleHomes = false;
        let trip_type = '';

        if(homes.FE && homes.INTERNAL){
            multipleHomes = true;
            trip_type = helpers.trip_type.FE;
            if(props.data && props.data.trip_type){
                trip_type = props.data.trip_type;
            }
        }else if(homes.FE){
            trip_type = helpers.trip_type.FE;
        }else if(homes.INTERNAL){
            trip_type = helpers.trip_type.INTERNAL;
        }

        this.state = {
            multipleHomes,
            trip_type
        }

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.multipleHomes){
            let trip_type = helpers.trip_type.FE;
            if(nextProps.data && nextProps.data.trip_type){
                trip_type = nextProps.data.trip_type;
            }
            if(this.state.operation_type !== trip_type){
                this.setState({trip_type}, this._fetchShipments);
            }
        }
    }

    componentDidMount(){
        if(helpers.isUserReport(this.props.user)){
            this.props.history.push('/reports');
        }
    }

    render() {
        if(helpers.isUserReport(this.props.user)) return <div />;

        return this.state.trip_type === helpers.trip_type.FE ? <HomeFE /> : <HomeInternal />;
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Home/home.js